export default __webpack_public_path__ + "static/media/KidOzAnges.61befd7d.jpg";